if (!global._babelPolyfill) {
    require('babel-polyfill')
};

import React from "react";
import { hashHistory } from "react-router";
import { connect } from "react-redux";

import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";

import PluginBilling from "../components/plugin-billing";

class NounProjectPluginBillingContainer extends React.Component {
    constructor(props) {
        super(props);

        this.props.getCurrentUser();

        this.state = {
            error: null,
            processing: false
        };
    }

    componentWillReceiveProps(nextProps) {
        let successTypes = [
            actionTypes.CREATE_STRIPE_TOKEN_SUCCESS,
            actionTypes.SAVE_CARD_SUCCESS,
            actionTypes.UPGRADE_BILLING_SUCCESS
        ],
            errorTypes = [
                actionTypes.CREATE_STRIPE_TOKEN_FAILURE,
                actionTypes.SAVE_CARD_FAILURE,
                actionTypes.UPGRADE_BILLING_FAILURE
            ];

        if (errorTypes.includes(nextProps.apiResponse.actionType)) {
            let error = {}, stripeError = nextProps.apiResponse;

            this.setState({
                processing: false
            });
            switch (stripeError.statusCode) {
                case "card_declined":
                    error["number"] = stripeError.error;
                    break;
                case "expired_card":
                    error["card_expiration"] = stripeError.error;
                    break;
                case "incorrect_cvc":
                    error["cvc"] = stripeError.error;
                    break;
            }

            this.setState({
                error: error
            });
        }

        if (successTypes.includes(nextProps.apiResponse.actionType)) {
            if (
                nextProps.apiResponse.actionType ==
                actionTypes.CREATE_STRIPE_TOKEN_SUCCESS
            ) {
                this.props.saveCreditCard(
                    nextProps.user,
                    nextProps.stripeToken
                );
            }

            if (
                nextProps.apiResponse.actionType ===
                actionTypes.SAVE_CARD_SUCCESS
            ) {
                this.props.upgradeToProAccount(
                    nextProps.user,
                    nextProps.stripeToken
                );
            }

            if (
                nextProps.apiResponse.actionType ===
                actionTypes.UPGRADE_BILLING_SUCCESS
            ) {
                hashHistory.push("confirmation");
            }
        }
    }

    render() {
        return (
            <div style={{ height: "100%" }}>
                <PluginBilling
                    submit={this.validateData.bind(this)}
                    error={this.state.error}
                    processing={this.state.processing}
                />
            </div>
        );
    }

    submitData(formData) {
        if(!this.state.processing){
            this.props.createStripeToken(formData, this.props.user);
            this.setState({
                error: null,
                processing: true
            });
        }
    }

    validateData(formData) {
        let card = {}, error = false, errors = {};

        formData.forEach(input => {
            if (input.number) {
                card.number = input.number;
                if (input.number === "") {
                    error = true;
                    errors.number = "This field is required.";
                }
            }
            if (input.cvc) {
                card.cvc = input.cvc;
                if (input.cvc === "") {
                    error = true;
                    errors.cvc = "This field is required.";
                }
            }
            if (input.exp_month) {
                card.exp_month = input.exp_month;
            }
            if (input.exp_year) {
                card.exp_year = input.exp_year;
            }
            if (input.exp_month === "" || input.exp_year === "") {
                error = true;
                errors.card_expiration = "This field is required.";
            }

            if (input.name) {
                card.name = input.name;
                if (input.name === "") {
                    error = true;
                    errors.name = "This field is required.";
                }
            }
        });

        // stripe validation
        if (!Stripe.card.validateExpiry(card.exp_month, card.exp_year)) {
            error = true;
            errors.card_expiration = "Expiration date is invalid.";
        }

        if (!Stripe.card.validateCVC(card.cvc)) {
            error = true;
            errors.cvc = "CVC is invalid.";
        }

        if (!Stripe.card.validateCardNumber(card.number)) {
            error = true;
            errors.number = "Card number is invalid.";
        }

        if (error) {
            this.setState({
                error: error,
                error: errors
            });
        } else {
            // convert to card object
            this.submitData(card);
        }
    }
}

NounProjectPluginBillingContainer.propTypes = {
    authType: React.PropTypes.string.isRequired,
    apiResponse: React.PropTypes.object,
    user: React.PropTypes.object
};

NounProjectPluginBillingContainer.contextTypes = {
    router: React.PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse, authType, user = state.user;

    if (ownProps.route) {
        if (ownProps.route.path === "billing") authType = "billing";
    }

    if (ownProps.authType) authType = ownProps.authType;

    return {
        apiResponse,
        authType,
        stripeToken: state.payments.stripeToken,
        user
    };
}

export default connect(mapStateToProps, {
    createStripeToken: actions.createStripeToken,
    getCurrentUser: actions.getCurrentUser,
    saveCreditCard: actions.saveCreditCard,
    updateCard: actions.updateCard,
    upgradeToProAccount: actions.upgradeToProAccount
})(NounProjectPluginBillingContainer);
